import React, { Fragment, PureComponent } from 'react';
import { Product } from '~/Product';
import InfoText, { Type as InfoTextType } from '~/UI/InfoText/InfoText';

interface Props {
	product: Product | null;
}

export default class Status extends PureComponent<Props> {
	renderFields(product: Product) {
		const {
			status: { reasonFields },
		} = product;
		const fields = Object.keys(reasonFields);

		if (fields.length === 0) {
			return null;
		}

		const parts = Object.keys(reasonFields)
			.map((field) => {
				const value = reasonFields[field];
				const hasValue = value !== null;
				return (
					<span key={field}>
						<strong>
							{field}
							{hasValue ? ':' : null}
						</strong>
						&nbsp;{hasValue ? value : 'has no value'}
					</span>
				);
			})
			.reduce((result: React.ReactNode[], value, index) => {
				if (index > 0) {
					result.push(', ');
				}
				result.push(value);
				return result;
			}, []);

		return (
			<Fragment>
				<br />
				Fields in question: {parts}
			</Fragment>
		);
	}

	render() {
		const { product } = this.props;

		if (product?.status.isRemoved()) {
			return (
				<InfoText header='Product is no longer present in current dataset.' type={InfoTextType.danger}>
					{this.renderFields(product)}
				</InfoText>
			);
		}

		if (product?.status.isDanger()) {
			return (
				<InfoText header={"This product shouldn't be used for referencing."} type={InfoTextType.danger}>
					Please check product details.
					{this.renderFields(product)}
				</InfoText>
			);
		}

		if (product?.status.isWarning()) {
			return (
				<InfoText header='This product might not be suitable for referencing.' type={InfoTextType.warning}>
					Please make sure this product can be used for your purpose.
					{this.renderFields(product)}
				</InfoText>
			);
		}

		if (product?.status.isBeforeValidity()) {
			return (
				<InfoText header='Product has validity that begins in the future.' type={InfoTextType.note}>
					Product might not be suitable for referencing yet.
					{this.renderFields(product)}
				</InfoText>
			);
		}

		if (product?.status.isAfterValidity()) {
			return (
				<InfoText header={'Product validity has ended.'} type={InfoTextType.warning}>
					To assess the product suitability for your needs, please check the product details.
					{this.renderFields(product)}
				</InfoText>
			);
		}

		return null;
	}
}
